// @flow

import React, { Component } from "react";
import type { SpecificationType } from "../types/product.js";
import ProductDetailsBlock from "../detail-block";

type Props = {
  specifications: Array<SpecificationType>
};

type State = {
  showDetails: boolean
};

class ProductDetails extends Component<Props, State> {
  constructor() {
    super();
    this.state = {
      showDetails: false
    };
  }

  toggle = () => this.setState({ showDetails: !this.state.showDetails });

  renderProductDetailsBlocks = (): Array<any> => {
    return this.props.specifications.map(specification => (
      <ProductDetailsBlock
        key={specification.name}
        title={specification.name}
        productAttributeList={specification.attributes}
      />
    ));
  };

  render() {
    const showDetailsClass = this.state.showDetails
      ? "wishlist-tile__section-details--active"
      : "";
    const detailContainerCls = `wishlist-tile__details-specification wishlist-tile__view-details--js ${
      this.state.showDetails
        ? "wishlist-tile__details-specification--expanded"
        : ""
    }`;

    return (
      <div className={"wishlist-tile__section-details " + showDetailsClass}>
        <div className={detailContainerCls}>
          {this.renderProductDetailsBlocks()}
        </div>

        <button
          className="wishlist-tile__toggle-details-btn wishlist-tile__toggle-detail--js"
          onClick={this.toggle}
        >
          {this.state.showDetails ? "Hide details" : "View details"}
        </button>
      </div>
    );
  }
}

export default ProductDetails;
